// 인증 관련 상수 정의

/**
 * 이메일 검증 정규식
 * - + 포함 이메일 허용 (예: test+tag@example.com)
 * - TLD 최소 2자 이상 (예: .com, .co.kr)
 *
 * @example
 * EMAIL_REGEX.test("user@example.com") // true
 * EMAIL_REGEX.test("user+tag@example.com") // true
 * EMAIL_REGEX.test("invalid@a.b") // false (TLD 1자)
 */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/**
 * 인증 설정 상수
 */
export const AUTH_CONFIG = {
  /** JWT 만료 시간 */
  JWT_EXPIRES_IN: "1d",

  /** 쿠키 이름 */
  COOKIE_NAME: "ict_token",

  /** 쿠키 만료 시간 (초) - 1일 */
  COOKIE_MAX_AGE: 60 * 60 * 24,

  /** 최대 로그인 시도 횟수 */
  MAX_LOGIN_ATTEMPTS: 5,

  /** 계정 잠금 시간 (밀리초) - 5분 */
  LOCKOUT_DURATION: 5 * 60 * 1000,
} as const;

/**
 * 인증 에러 코드
 */
export const AUTH_ERROR_CODES = {
  /** 잘못된 자격증명 */
  INVALID_CREDENTIALS: "INVALID_CREDENTIALS",

  /** 계정 잠금 */
  ACCOUNT_LOCKED: "ACCOUNT_LOCKED",

  /** 유효성 검사 실패 */
  VALIDATION_ERROR: "VALIDATION_ERROR",

  /** 인증되지 않음 */
  UNAUTHENTICATED: "UNAUTHENTICATED",

  /** 사용자 없음 */
  USER_NOT_FOUND: "USER_NOT_FOUND",

  /** 아이디 중복 */
  DUPLICATE_ID: "DUPLICATE_ID",

  /** 내부 서버 오류 */
  INTERNAL_ERROR: "INTERNAL_ERROR",
} as const;

/**
 * 사용자 직급 목록
 */
export const USER_GRADES = [
  "최고관리자",
  "이사",
  "수석",
  "사장",
  "전무",
  "상무",
  "부장",
  "차장",
  "과장",
  "대리",
  "사원",
] as const;

/**
 * 사용자 직급 타입
 */
export type UserGrade = (typeof USER_GRADES)[number];

/**
 * 인증 에러 코드 타입
 */
export type AuthErrorCode = (typeof AUTH_ERROR_CODES)[keyof typeof AUTH_ERROR_CODES];
